import { render } from "./LoginSettings.vue?vue&type=template&id=82eb4bf6&scoped=true"
import script from "./LoginSettings.vue?vue&type=script&lang=js"
export * from "./LoginSettings.vue?vue&type=script&lang=js"

import "./LoginSettings.vue?vue&type=style&index=0&id=82eb4bf6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82eb4bf6"]])

export default __exports__